import { rootRoute } from "./root";
import { homeRoute } from "./home";
import { scriptDetailRoute } from "./script-detail";
import { reviewRoute } from "./review";
import { reviewScriptDetailRoute } from "./review-script-detail";
import { reviewLeaderboardRoute } from "./review-leaderboard";
import { reviewDevicesRoute } from "./review-devices";

export const routeTree = rootRoute.addChildren([
  homeRoute,
  scriptDetailRoute,
  reviewRoute,
  reviewScriptDetailRoute,
  reviewLeaderboardRoute,
  reviewDevicesRoute,
]);
